module.exports = __webpack_public_path__ + "static/media/pandaria-2.e0c1ca1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pandaria-2.jpg
// module id = 104
// module chunks = 0